import { ChangeDetectionStrategy, Component, inject, output } from '@angular/core'
import { Router } from '@angular/router'
import { TranslocoDirective } from '@jsverse/transloco'
import { appPages } from '@/routes/app-pages'

/**
 * "Don't have an account? Register", the auth modals' way to registration.
 * Emits `navigated` once it leaves for the register page, so the modal can close.
 */
@Component({
	selector: 'register-prompt',
	imports: [TranslocoDirective],
	changeDetection: ChangeDetectionStrategy.OnPush,
	styles: `
		:host {
			display: flex;
			flex-wrap: wrap;
			align-items: center;
			justify-content: center;
			gap: 4px;
			padding: 8px 0;
			font-size: var(--font-size-medium);
			color: var(--modal-light-text-subtle);
		}

		.register-link {
			padding: 0;
			border: none;
			background: none;
			color: var(--modal-light-text);
			font: inherit;
			text-decoration: underline;
			text-underline-position: from-font;
			cursor: pointer;
		}

		.register-link:focus-visible {
			outline: var(--outline-2-accent-primary);
			outline-offset: 2px;
		}
	`,
	template: `
		<ng-container *transloco="let t">
			<span>{{ t('message.info.dontHaveAnAccount') }}</span>
			<button class="register-link" type="button" (click)="register()">{{ t('actions.register') }}</button>
		</ng-container>
	`
})
export class RegisterPromptComponent {
	readonly navigated = output<void>()

	private readonly router = inject(Router)

	protected register(): void {
		void this.router.navigate([appPages.register.href])
		this.navigated.emit()
	}
}
